import type { IconProp } from '@fortawesome/fontawesome-svg-core';

import { FavoritePageEnum } from '../enums';

export const PAGE_NAV_ICON_BY_PAGE: Record<FavoritePageEnum, IconProp> = {
  [FavoritePageEnum.DASHBOARD]: ['fal', 'house'],

  // Discover Prospects (top-level nav icon: magnifying-glass)
  [FavoritePageEnum.PROSPECT_INTEL]: ['fal', 'magnifying-glass'],
  [FavoritePageEnum.ICP_INTEL]: ['fal', 'magnifying-glass'],
  [FavoritePageEnum.INBOX_INTEL]: ['fal', 'magnifying-glass'],
  [FavoritePageEnum.RESEARCH_ON_DEMAND]: ['fal', 'magnifying-glass'],
  [FavoritePageEnum.VISITOR_INTEL]: ['fal', 'magnifying-glass'],
  [FavoritePageEnum.SAVED_SEARCHES]: ['fal', 'magnifying-glass'],
  [FavoritePageEnum.LISTS]: ['fal', 'magnifying-glass'],
  [FavoritePageEnum.REP_INTEL]: ['fal', 'magnifying-glass'],

  // Build AI Workflows (top-level nav icon: circle-play)
  [FavoritePageEnum.AGENTIC_WORKFLOWS]: ['fal', 'circle-play'],
  [FavoritePageEnum.AI_GENERATED_CONTENT]: ['fal', 'circle-play'],

  // Enrich Data (top-level nav icon: file-user)
  [FavoritePageEnum.HUBSPOT_ENRICHMENT]: ['fal', 'file-user'],
  [FavoritePageEnum.CUSTOM_ENRICHMENT]: ['fal', 'file-user'],
  [FavoritePageEnum.FORMS_INTEL]: ['fal', 'file-user'],
  [FavoritePageEnum.BOUNCE_INTEL]: ['fal', 'file-user'],
};

export function getNavIconForPage(page: FavoritePageEnum | null | undefined): IconProp | null {
  return page ? PAGE_NAV_ICON_BY_PAGE[page] : null;
}

